<template>
  <b-container fluid>
    <no-permission v-if="!hasPermission" />
    <b-tabs v-else>
      <b-tab>
        <template #title>
          <feather-icon icon="UserIcon" />
          Boleto
        </template>

        <bankSlip :items="bankslip" />
      </b-tab>

      <b-tab>
        <template #title>
          <feather-icon icon="LinkIcon" />
          Recorrência
        </template>

        <recurrence :items="recurrence" />
      </b-tab>

      <b-tab>
        <template #title>
          <feather-icon icon="LockIcon" />
          Transação
        </template>

        <direct-sale :items="transaction" />
      </b-tab>
    </b-tabs>
  </b-container>
</template>

<script>
import { BContainer, BTabs, BTab } from 'bootstrap-vue'

import BankSlip from './BankSlip.vue'
import Recurrence from './Recurrence.vue'
import DirectSale from './DirectSale.vue'

import NoPermission from '@/views/error/NoPermission.vue'

import { getMerchantData } from '@/utils/get-merchant-data'

import { getMercuryBankslips, getMercuryRecurrence, getMercuryTransactions } from '@/service/integration'
import { callLoading } from '@/service/utilities/utilities'

export default {
  components: {
    BankSlip,
    DirectSale,
    Recurrence,
    BContainer,
    BTabs,
    BTab,
    NoPermission,
  },

  data() {
    return {
      recurrence: [],
      bankslip: [],
      transaction: [],
      hasPermission: getMerchantData().permissions.map(permission => +permission).map(permission => +permission).some(permission => permission === 56),
    }
  },

  async created() {
    callLoading(true)
    await this.getFetchDataRecurrence()
    await this.getFetchDataTransactions()
    await this.getFetchDataBankslip()
    callLoading(false)
  },

  methods: {
    async getFetchDataRecurrence(id = 1) {
      const { data, status } = await getMercuryRecurrence()
      if (status === 200) {
        this.recurrence = data.data
      }
    },

    async getFetchDataTransactions(id = 1) {
      const { data, status } = await getMercuryTransactions()
      if (status === 200) {
        this.transaction = data.data
      }
    },

    async getFetchDataBankslip(id = 1) {
      const { data, status } = await getMercuryBankslips()
      if (status === 200) {
        this.bankslip = data.data
      }
    },
  },
}
</script>

<style>

</style>
